import { render, staticRenderFns } from "./Vaptcha.vue?vue&type=template&id=69dd8227&"
import script from "./Vaptcha.vue?vue&type=script&lang=js&"
export * from "./Vaptcha.vue?vue&type=script&lang=js&"
import style0 from "./Vaptcha.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports